export const getModalProviderStack = state =>
  state.modalProvider?.stack ?? [];

export const getHasVisibleModal = state =>
  getModalProviderStack(state).some(modal => modal.show === true);
